export const formatCurrency = (value = 0) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('pt-BR');
};

export const formatDateFull = (dateStr) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
};

export const todayISO = () => new Date().toISOString().split('T')[0];

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Bom dia';
  if (h < 18) return 'Boa tarde';
  return 'Boa noite';
};

export const formatDateChip = () => {
  const d = new Date();
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
};

// Data local (YYYY-MM-DD) — evita o desvio de fuso do toISOString().
export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Data em que o lançamento vence (ou foi pago): pagamento, senão competência.
export const dataVencimento = (l) => ((l && (l.dataPagamento || l.dataCompetencia)) || '').slice(0, 10);

// Atrasado = status gravado como atrasado OU pendente com vencimento já passado.
export const isAtrasado = (l, hoje = todayLocal()) => {
  if (!l) return false;
  if (l.status === 'atrasado') return true;
  // Compra no cartão vence na fatura (não no dia da compra): não deriva atraso pela data.
  if (l.cartaoId) return false;
  const venc = dataVencimento(l);
  return l.status === 'pendente' && !!venc && venc < hoje;
};

// Status para exibir: receita vencida e não recebida vira "inadimplente".
export const statusEfetivo = (l) => (isAtrasado(l) ? (l.tipo === 'RECEITA' ? 'inadimplente' : 'atrasado') : l.status);
